import Select from "react-select";
import { useEffect, useState, useContext, useRef } from "react";
import customStyles from "../../../frontend/styles/select";
import customStyles_v2 from "../../../frontend/styles/select_v2";
import { DataContext } from "../../../context/DataContext";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import productEmpty_light from "../../../frontend/assets/img/spot-illustrations/35.png";
import productEmpty_dark from "../../../frontend/assets/img/spot-illustrations/35_2.png";
import { useForm } from "react-hook-form";
import Table from "../../componentsTable/TableVenta";
import {
  EditableCellNumber,
  EditableCellTextarea,
} from "../../componentsTools/EditableCell";
import { useWatch } from "react-hook-form";
import { NavLink,useLocation } from "react-router-dom";
import {
  deleteIGVDefault,
  deleteProductDefault,
  addProduct,
  setValueTableDefault,
  calculateAmountsVenta,
  calculateAmountsCompra,
} from "../../../utils/helpers";

export default function NuevaEs() {
  const { session, empresa, idEmpresa, user } = useContext(DataContext);
  const shownRef = useRef(false);

  const location = useLocation();
  const body = location.state?.body;

  const [type, setType] = useState("P");
  const [series, setSeries] = useState([]);
  const [serComprobante, setSerComprobante] = useState({
    entrada: "",
    remitente: "",
    transportista: "",
  });
  const [pservicio, setPservicio] = useState([]);
  const [producto, setProducto] = useState(null);
  const [cantidad, setCantidad] = useState("");
  const [precio, setPrecio] = useState("");
  const [igv, setIgv] = useState(true);
  const [moneda, setMoneda] = useState([]);
  const [idMoneda, setIdMoneda] = useState(body?.status ? (body?.type === "E") ? body.compra.idMoneda :body.venta.idMoneda : "1");
  const [descuento, setDescuento] = useState(body?.status ?(body?.type === "E") ? body.compra.dsctoTasa01.toString() :  body.venta.dsctoTasa01.toString() : "");
  const [area, setArea] = useState([]);
  const [local, setLocal] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [almacen, setAlmacen] = useState([]);
  const [tipTraslado, setTipTraslado] = useState([]);
  const [conductor, setConductor] = useState([]);
  const [vehiculo, setVehiculo] = useState([]);
  const [id, setId] = useState("");

  const [estado, setEstado] = useState(body?.status ? (body?.type === "E") ? true : false : true);

  //REFS
  const comp = useRef("");
  const monto = useRef("");
  const money = useRef("");

  const modalConfirmacion = useRef(null);
  const modalConfiguracion = useRef(null);
  const modalEmail = useRef(null);
  const modalWsp = useRef(null);

  const [data, setData] = useState(body?.status ? body.detalle : []);

  const stadicts = (() => {
    const IGV_RATE = 0.18;

    // Calcular afecto en base imponible (sin IGV)
    const impAfecto = data.reduce(
      (acc, item) => (item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc),
      0
    );

    const impInafecto = data.reduce(
      (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
      0
    );

    const dsctTasa = Number(descuento) || 0;

    // Descuento solo sobre lo afecto
    const dsctImp = impAfecto * (dsctTasa / 100);

    const baseNeta = impAfecto - dsctImp;
    const igv = baseNeta * IGV_RATE;

    return {
      subtotal: baseNeta + impInafecto, // sin IGV
      igv,
      total: baseNeta + impInafecto + igv,
      descuento: dsctImp,
    };
  })();

  const entrada = useForm({
    defaultValues: {
      tipComprobante: "GE",
      serComprobante: "0001",
      fecOperacion: new Date().toLocaleDateString('en-CA', { timeZone: 'America/Lima' }),
      idMoneda: "1",
      idLocal: "",
      glosa: (body?.status && body?.type === "E")  ? body?.compra?.glosa ?? "" : "",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      impuesto: 0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      idArea: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      despachado: "N",
      idAlmacen: "",
      stock: (body?.status && body?.type === "E") ? ((body.compra.stock === "S") ? "N" : "S")  : "S"
    },
  });

  const salida = useForm({
    defaultValues: {
      tipComprobante: "",
      serComprobante: "T001",
      fecOperacion: new Date().toLocaleDateString('en-CA', { timeZone: 'America/Lima' }),
      idMoneda: "1",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      impuesto: 0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      idVehiculo: "",
      idTranportista: "", 
      idConductor: "",
      idTipTraslado: "",
      puntPartida: (body?.status && body?.type === "S")  ? body?.venta?.puntPartida ?? "" : "",
      puntLlegada: (body?.status && body?.type === "S")  ? body?.venta?.puntLlegada ?? "" : "",
      idAlmacen: "",
      stock: (body?.status && body?.type === "S") ? ((body.venta.stock === "S") ? "N" : "S")  : "S"
    },
  });

  const form1 = useForm({
    defaultValues: {
      email: "",
    },
  });

  const form2 = useForm({
    defaultValues: {
      numero: "",
      indice: "51",
    },
  });

  const tipo = useWatch({ control: salida.control, name: "tipComprobante" });

  const setValueTable = (row) => {
    setValueTableDefault(row, setData);
  };

  const columns = [
    {
      header: (
        <th
          className="sort white-space-nowrap align-middle"
          scope="col"
          style={{ minWidth: "200px" }}
        >
          PRODUCTO / SERVICIO
        </th>
      ),
      accessorKey: "nombreAlternativo",
      cell: ({ row }) => (
        <EditableCellTextarea
          value={row.original.nombreAlternativo}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="nombreAlternativo"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "150px" }}
        >
          CANTIDAD
        </th>
      ),
      accessorKey: "cantidad",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.cantidad}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="cantidad"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "300px" }}
        >
          PRECIO U.
        </th>
      ),
      accessorKey: "precio",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.precio}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="precio"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          DESCUENTO
        </th>
      ),
      accessorKey: "dscto01",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.dscto01}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="dscto01"
          clase="badge badge-phoenix fs-10 badge-phoenix-info rounded-4"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          SUB TOTAL
        </th>
      ),
      accessorKey: "subtotal",
      cell: ({ row }) => (
        <td className="color align-middle white-space-nowrap text-body py-0 text-end">
          {parseFloat(row.original.subtotal).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "250px" }}
        >
          TOTAL
        </th>
      ),
      accessorKey: "importe",
      cell: ({ row }) => (
        <td className="total align-middle fw-bold text-body-highlight text-end py-0">
          {parseFloat(row.original.importe).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "10px" }}
        ></th>
      ),
      accessorKey: "acciones",
      cell: ({ row }) => {
        const igvColor =
          row.original.igv === "S" ? "text-primary" : "text-secondary";
        return (
          <td className="total align-middle fw-bold text-body-highlight text-end py-1">
            <div className="row justify-content-end g-0">
              <div
                className="col-auto"
                onClick={() => {
                  deleteProduct(row.index);
                }}
              >
                <span
                  className="text-danger uil-trash-alt"
                  title="Eliminar"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
              <div
                className="col-auto"
                onClick={() => {
                  deleteIGV(row.index);
                }}
              >
                <span
                  className={`${igvColor} uil-file-upload-alt`}
                  title="IGV"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const deleteIGV = (rowIndex) => {
    deleteIGVDefault(rowIndex, setData);
  };

  const deleteProduct = (index) => {
    deleteProductDefault(index, setData);
  };

  useEffect(() => {
    if (!shownRef.current) {
      if (body?.status) {
        if (body?.type === "S" && body?.venta.stock === "S") {
          toast.warning("Este comprobante no va afectar stock.");
        }
        if (body?.type === "E" && body?.compra.stock === "S") {
          toast.warning("Este comprobante no va afectar stock.");
        }
        if (body?.type === "S") {
          toast(
            "¿Qué tipo de guía de remisión desea emitir?",
            {
              description: (
                <div className="row mt-2">
                  <div className="col-6 d-flex justify-content-center">
                    <button
                      className="btn btn-outline-primary btn-sm text-wrap"
                      type="button"
                      onClick={() => {
                        salida.setValue(
                          "tipComprobante",
                          "09",
                          {
                            shouldValidate: true,
                          }
                        );
                        toast.dismiss();
                      }}
                    >
                      Remitente
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center">
                    <button
                      className="btn btn-outline-primary btn-sm text-wrap"
                      type="button"
                      onClick={() => {
                        salida.setValue(
                          "tipComprobante",
                          "31",
                          {
                            shouldValidate: true,
                          }
                        );
                        toast.dismiss();
                      }}
                    >
                      Transportista
                    </button>
                  </div>
                </div>
              ),
            }
          );
        }
      }
      shownRef.current = true;
    }
  }, [body, estado, salida]);

  useEffect(() => {
    const axiosProducts = async () => {
      const response = await petitions.getProductsType(
        idEmpresa(),
        session().token,
        type
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProducto,
          label: e.nombre,
          pventa: e.pVenta,
          pcompra: e.pCompra,
          stock: e.stock
        }));
        setPservicio(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    axiosProducts();
  }, [idEmpresa, session, type]);

  useEffect(() => {
    const fetchSeries = async () => {
      const obj = session();
      const response = await petitions.getSeries(idEmpresa(), obj.token);

      if (response.status === "success") {
        const data = response.data;

        // 🔎 solo trabajamos con las series habilitadas
        const habilitadas = data.filter((s) => s.estado === "S");

        setSeries(habilitadas);

        // --- lógica de selección automática ---
        if (habilitadas.length === 0) {
          setSerComprobante({ entrada: "", remitente: "", transportista: "" });
          return;
        }

        const entrada = habilitadas.filter((s) => s.tipComprobante === "GE");
        const entradaDefecto = entrada.find((s) => s.defecto === "S");

        const remitente = habilitadas.filter((s) => s.tipComprobante === "09");
        const remitenteDefecto = remitente.find((s) => s.defecto === "S");

        const transportista = habilitadas.filter((s) => s.tipComprobante === "31");
        const transportistaDefecto = transportista.find((s) => s.defecto === "S");

        setSerComprobante({
          entrada: entradaDefecto
            ? entradaDefecto.serie
            : entrada[0]?.serie || "",
          remitente: remitenteDefecto
            ? remitenteDefecto.serie
            : remitente[0]?.serie || "",
          transportista: transportistaDefecto
            ? transportistaDefecto.serie
            : transportista[0]?.serie || "",
        });
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchSeries();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: e.simbolo,
        }));
        setMoneda(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMoneda();
  }, [idEmpresa, session]);


  useEffect(() => {
    const fetchAreas = async () => {
      const obj = session();
      const response = await petitions.getAreas(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idArea,
          label: e.nomArea,
        }));

        setArea(array);

        entrada.setValue(
          "idArea",
          body?.status && body?.type === "E" ? body?.compra?.idArea ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAreas();
  }, [idEmpresa, session, body?.status, body?.type, body?.compra?.idArea, entrada]);

  useEffect(() => {
  const fetchLocal = async () => {
    const obj = session();
    const response = await petitions.getLocal(idEmpresa(), obj.token);

    if (response.status === "success") {
      const array = response.data.map((e) => ({
        value: e.idLocal,
        label: e.nomLocal,
      }));

      setLocal(array);

      entrada.setValue(
        "idLocal",
        body?.status && body?.type === "E" ? body?.compra?.idlocal ?? "" : "",
        { shouldValidate: false }
      );
    } else {
      const msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  fetchLocal();
}, [idEmpresa, session, body?.status, body?.type, body?.compra?.idlocal, entrada]);


  useEffect(() => {
    const fetchClientes = async () => {
      const obj = session();
      const response = await petitions.getClientesSelect(
        idEmpresa(),
        obj.token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setClientes(array);

        entrada.setValue(
          "idcont",
          body?.status && body?.type === "E" ? body?.compra?.idcont ?? "" : "",
          { shouldValidate: false }
        );

        salida.setValue(
          "idcont",
          body?.status && body?.type === "S" ? body?.venta?.idcont ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchClientes();
  }, [idEmpresa, session, body?.status, body?.type, body?.compra?.idcont, body?.venta?.idcont, entrada, salida]);


  useEffect(() => {
    const fetchTipTraslado = async () => {
      const obj = session();
      const response = await petitions.getTipTraslado(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setTipTraslado(array);

        salida.setValue(
          "idTipTraslado",
          body?.status && body?.type === "S" ? body?.venta?.idTipTraslado ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTipTraslado();
  }, [idEmpresa, session, body?.status, body?.type, body?.venta?.idTipTraslado, salida]);


 useEffect(() => {
    const fetchConductores = async () => {
      const obj = session();
      const response = await petitions.getConductor(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idConductor,
          label: `${e.nombre} ${e.paterno} ${e.materno}`,
        }));

        setConductor(array);

        salida.setValue(
          "idConductor",
          body?.status && body?.type === "S" ? body?.venta?.idConductor ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchConductores();
  }, [idEmpresa, session, body?.status, body?.type, body?.venta?.idConductor, salida]);


 useEffect(() => {
    const fetchVehiculos = async () => {
      const obj = session();
      const response = await petitions.getVehiculos(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.placa,
          label: e.placa,
        }));

        setVehiculo(array);

        salida.setValue(
          "idVehiculo",
          body?.status && body?.type === "S" ? body?.venta?.idVehiculo ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchVehiculos();
  }, [idEmpresa, session, body?.status, body?.type, body?.venta?.idVehiculo, salida]);


  useEffect(() => {
    const fetchAlmacen = async () => {
      const response = await petitions.getAlmacen(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data
          .filter((e) => e.estado === "S")
          .map((e) => ({
            value: e.idAlmacen,
            label: e.nombre,
          }));

        setAlmacen(array);

        entrada.setValue(
          "idAlmacen",
          body?.status && body?.type === "E" ? body?.compra?.idAlmacen ?? "" : "",
          { shouldValidate: false }
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAlmacen();
  }, [idEmpresa, session, body?.status, body?.type, body?.compra?.idAlmacen, entrada]);


  const sendInventario = estado
    ? entrada.handleSubmit(async (form) => {
        if (serComprobante.entrada === "") {
          toast.warning("Debe seleccionar una serie para la entrada.")
          return;
        }
    
        form.serComprobante = serComprobante.entrada
        const maestro = calculateAmountsCompra(form, data, descuento);
        maestro.idMoneda = idMoneda;

        var join = {
          entrada: maestro,
          detalle: data,
        };

        toast("¿Estas seguro(a) de registrar esta entrada?", {
          action: {
            label: "Confirmar",
            onClick: async () => {
              const response = await petitions.insertEntrada(
                idEmpresa(),
                session().token,
                join
              );
              if (response.status === "success") {
                setId(response.data.idCompras);
                comp.current =
                  response.data.tipComprobante +
                  "-" +
                  response.data.serComprobante +
                  "-" +
                  response.data.numComprobante;
                monto.current = response.data.impTotal;
                money.current = moneda.find((m) => m.value === idMoneda)?.label;
                const modal = new window.bootstrap.Modal(
                  modalConfirmacion.current
                );
                modal.show();
                entrada.reset();
                setData([]);
              } else {
                var msg =
                  typeof response.code === "string"
                    ? response.message
                    : response.data;
                toast.error(msg);
              }
            },
          },
        });
      })
    : salida.handleSubmit(async (maestro) => {
        const field = maestro.tipComprobante === "09" ? "remitente" : "transportista";
        if (serComprobante[field] === "") {
          toast.warning("Debe seleccionar una serie para la salida.")
          return;
        }
    
        maestro.serComprobante = (maestro.tipComprobante === "09") ? serComprobante.remitente : serComprobante.transportista
        if (maestro.tipComprobante === "") {
          toast("¿Qué tipo de guía de remisión desea emitir?", {
            description: (
              <div className="row mt-2">
                <div className="col-6 d-flex justify-content-center">
                  <button
                    className="btn btn-outline-primary btn-sm text-wrap"
                    type="button"
                    onClick={() => {
                      salida.setValue("tipComprobante", "09", {
                        shouldValidate: true,
                      });
                      maestro.tipComprobante = "09";
                      toast.dismiss();
                      procesarSalida(maestro);
                    }}
                  >
                    Remitente
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    className="btn btn-outline-primary btn-sm text-wrap"
                    type="button"
                    onClick={() => {
                      salida.setValue("tipComprobante", "31", {
                        shouldValidate: true,
                      });
                      maestro.tipComprobante = "31";
                      toast.dismiss();
                      procesarSalida(maestro);
                    }}
                  >
                    Transportista
                  </button>
                </div>
              </div>
            ),
          });
        } else {
          await procesarSalida(maestro);
        }
      });

  const procesarSalida = async (form) => {
    const maestro = calculateAmountsVenta(form, data, descuento);
    maestro.idMoneda = idMoneda;

    const join = {
      salida: maestro,
      detalle: data,
    };

    toast("¿Estas seguro(a) de registrar esta salida?", {
      action: {
        label: "Confirmar",
        onClick: async () => {
          const response = await petitions.insertSalida(
            idEmpresa(),
            session().token,
            join
          );
          if (response.status === "success") {
            setId(response.data.idVenta);
            comp.current =
              response.data.tipComprobante +
              "-" +
              response.data.serComprobante +
              "-" +
              response.data.numComprobante;
            monto.current = response.data.impTotal;
            money.current = moneda.find((m) => m.value === idMoneda)?.label;
            const modal = new window.bootstrap.Modal(modalConfirmacion.current);
            modal.show();
            salida.reset();
            setData([]);
          } else {
            const msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        },
      },
    });
  };

  const abrirModalEmailInventario = () => {
    form1.reset();
    const modal = new window.bootstrap.Modal(modalEmail.current); 
    modal.show();
  };

  const abrirModalWspInventario = async () => {
    form2.reset();
    const modal = new window.bootstrap.Modal(modalWsp.current); 
    modal.show();
  }

  const getReportInventario = async () => {
    const response = estado ? await petitions.getReportEntrada(
      idEmpresa(),
      session().token,
      id
    ) : await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      id,
    )

    if (response.isError) {
      toast.error(response.data || "No se pudo obtener el reporte");
      return;
    }

    const blob = new Blob([response.blob], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${comp.current}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  }

  const sendEmail = form1.handleSubmit(async (data) => {
    const promise =  estado ? petitions.sendEmailCompra(
      idEmpresa(),
      session().token,
      id,
      data.email
    ): petitions.sendEmailVenta(
        idEmpresa(),
        session().token,
        id,
        data.email
      );

    toast.promise(promise, {
      loading: 'Enviando email...',
      success: (response) => {
        if (response.status === "success") {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEmail.current);
          modalInstance.hide();
          return "Email enviado correctamente";
        } else {
          throw new Error(response.message || response.data || "Error desconocido");
        }
      },
      error: (err) => {
        if (err?.status === "error") {
          return err.message || err.data || "Error al enviar el email";
        }
        return "Error... :( Intenta de nuevo!";
      }
    });
  });

  const sendWsp = form2.handleSubmit(async (data) => {
    const response = estado ? await petitions.getReportEntrada(
      idEmpresa(),
      session().token,
      id
    ) : await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      id
    )

    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    var url = `https://wa.me/${data.indice}${data.numero}?text=${"Buenas tardes, adjunto el comprobante electronico: " + fileURL}`;
    window.open(url, '_blank'); 

    const modalInstance = window.bootstrap.Modal.getInstance(modalWsp.current);
    modalInstance.hide();
    toast.success("Mensaje enviado por WhatsApp");
  })

  return (
    <>
      <div className="row justify-content-between align-items-end g-3 mb-4">
        <div className="col-12 col-sm-auto col-xl-8">
          <h2 className="mb-0">Nueva entrada / salida</h2>
        </div>
        <div className="col-12 col-sm-auto col-xl-4">
          <div className="d-flex">
            <select
              className="form-control form-control-sm me-2 rounded-4 border-0 shadow-sm"
              value={idMoneda}
              onChange={(event) => {
                setIdMoneda(event.target.value);
              }}
            >
              {moneda.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <button
              className="btn px-3 btn-phoenix-secondary px-3 me-2 rounded-4"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              onClick={() => {
                const modal = new window.bootstrap.Modal(
                  modalConfiguracion.current
                );
                modal.show();
              }}
            >
              <span
                className="fas fa-cog text-primary"
                data-fa-transform="down-3"
              ></span>
            </button>
            <button className="btn btn-phoenix-primary px-3 me-2 rounded-4" onClick={()=>{
              estado ? entrada.reset() : salida.reset()
              setData([])
              setDescuento("")
              setIdMoneda("1")
            }}>
              Cancelar
            </button>
            <form onSubmit={sendInventario}>
              <button
                className="btn btn-primary px-5 w-100 text-nowrap rounded-4"
                href="event-detail.html"
                disabled={data.length === 0}
              >
                Guardar
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="row g-5">
        <div className="col-xl-8">
          <div className="row gx-3 gy-4 mb-4">
            <div className="row g-2">
              <div className="col-md-2">
                <div className="d-flex">
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "P" ? "active" : ""
                    }`}
                    title="Producto"
                    onClick={() => {
                      setProducto(null);
                      setType("P");
                    }}
                  >
                    {" "}
                    <span className="fas fa-book"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "S" ? "active" : ""
                    }`}
                    title="Servicio"
                    onClick={() => {
                      setProducto(null);
                      setType("S");
                    }}
                  >
                    {" "}
                    <span className="fas fa-wrench"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg rounded-3 ${
                      type === "Q" ? "active" : ""
                    }`}
                    title="Paquete"
                    onClick={() => {
                      setProducto(null);
                      setType("Q");
                    }}
                  >
                    <span className="fas fa-box-open"></span>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-5">
                <Select
                  className="mb-0 mi-select"
                  classNamePrefix="rs"  
                  options={pservicio}
                  value={producto}
                  styles={customStyles_v2}
                  placeholder={
                    type === "P"
                      ? "Buscar Producto"
                      : type === "S"
                      ? "Buscar Servicio"
                      : type === "Q"
                      ? "Buscar Paquete"
                      : "Buscar..."
                  }
                  isLoading={false}
                  isClearable={true}
                  onChange={(event) => {
                    if (!event) {
                      setProducto(null);
                      setCantidad(0);
                      setPrecio(0);
                    } else {
                      setProducto(event);
                      setCantidad(1);
                      estado ? setPrecio(event.pcompra) : setPrecio(event.pventa);
                    }
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-email"
                  id="add-property-wizardwizard-email"
                  placeholder="Cantidad"
                  value={cantidad}
                  onChange={(event) => {
                    setCantidad(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-phone"
                  id="add-property-wizardwizard-phone"
                  placeholder="Precio"
                  value={precio}
                  onChange={(event) => {
                    setPrecio(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-1">
                <button
                  className="btn btn-phoenix-secondary px-3 me-2 rounded-4"
                  type="button"
                  data-boundary="window"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-reference="parent"
                  disabled={!producto || Object.keys(producto).length === 0}
                  onClick={() => {
                    if (empresa.validarAlmacen === "S" && !estado && producto.stock <= 0) {
                      toast.warning("No hay stock disponible para " + producto.label);
                      return;
                    }
                    if (empresa.validarAlmacen === "S" && !estado && producto.stock < cantidad) {
                      toast.warning("Cantidad supera el stock disponible (" + producto.stock + ")");
                      return;
                    }
                    if (empresa.validarAlmacen === "S" && !estado && cantidad <= 0) {
                      toast.warning("La cantidad debe ser mayor a 0");
                      return;
                    }

                    addProduct(producto, cantidad, precio, igv, setData, setProducto, setCantidad, setPrecio, user?.idUsuario);
                  }}
                >
                  <span
                    className="fas fa-plus text-success"
                    data-fa-transform="down-2"
                  ></span>
                </button>
              </div>
            </div>
          </div>
          <div className="row g-5 gy-7">
            <div className="col-12 col-xl-12 col-xxl-12">
              <div
                id="orderTable"
                data-list='{"valueNames":["products","color","size","price","quantity","total"],"page":10}'
                className="mb-3"
              >
                <div className="table-responsive scrollbar">
                  <Table data={data} columns={columns} />
                </div>
              </div>
              {data.length > 0 ? (
                <>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <span className="badge badge-phoenix fs-10 badge-phoenix-secondary mt-1 mb-2 me-4 rounded-3 border-0 shadow-sm">
                      <span className="far fa-lightbulb me-1"></span> 
                      El descuento afecta solo a operaciones gravadas
                    </span>
                    <p className="text-body-emphasis  lh-sm mb-0 me-5 mt-1">
                      Descuentos (%)
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2 mt-1">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <input
                      type="number"
                      placeholder="Descuento"
                      className="form-control form-control-sm text-star rounded-4 border-0 shadow-sm"
                      style={{ minWidth: "130px", maxWidth: "120px" }}
                      value={!data.some(item => item.igv === "S") ? 0 : descuento}
                      onChange={(e) => setDescuento(e.target.value)}
                      disabled={!data.some(item => item.igv === "S")}
                    />
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">
                      Subtotal
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.subtotal).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">IGV</p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.igv).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis fw-semibold lh-sm mb-0 me-5">
                      Total
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-bold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.total).toFixed(2)}
                    </p>
                  </div>
                </>
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <img
                    className="d-dark-none mt-5 position-sticky"
                    src={productEmpty_light}
                
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />
                  <img
                    className="d-light-none mt-5 position-sticky"
                    src={productEmpty_dark}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />

                  <h5 className="text-muted mt-3" style={{opacity: "0.5"}}>No hay productos</h5>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="border-translucent pb-6 mb-1">
            <div className="card mb-3 rounded-4 border-0 shadow-sm">
              <div className="card-body">
                <div className="row gx-3">
                  <div className="col-12 col-sm-6 col-xl-12">
                    <ul
                      className="nav nav-underline w-100 d-flex"
                      id="myTab"
                      role="tablist"
                    >
                      <li
                        className="nav-item flex-fill text-center"
                        role="presentation"
                      >
                        <a
                          className={ "nav-link " + (estado ? "active" : "") + ((body?.status && body?.type === "S") ? " disabled" : "")}
                          id="home-tab"
                          data-bs-toggle="tab"
                          href="#tab-home"
                          role="tab"
                          aria-controls="tab-home"
                          aria-selected={estado ? "true" : "false"}
                          onClick={(e) => {
                            if (body?.status && body?.type === "S") {
                              e.preventDefault(); // bloquear interacción
                              return;
                            }
                            salida.setValue("tipComprobante", "GE", {
                              shouldValidate: true,
                            });
                            setEstado(true);
                          }}
                        >
                          Entrada
                        </a>
                      </li>
                      <li
                        className="nav-item flex-fill text-center"
                        role="presentation"
                      >
                        <a
                          className={"nav-link " + (!estado ? "active" : "") + ((body?.status && body?.type === "E") ? " disabled" : "")}
                          id="profile-tab"
                          data-bs-toggle="tab"
                          href="#tab-profile"
                          role="tab"
                          aria-controls="tab-profile"
                          aria-selected={estado ? "true" : "false"}
                          onClick={(e) => {
                            if (body?.status && body?.type === "E") {
                              e.preventDefault(); // bloquear interacción
                              return;
                            }

                            toast(
                              "¿Qué tipo de guía de remisión desea emitir?",
                              {
                                description: (
                                  <div className="row mt-2">
                                    <div className="col-6 d-flex justify-content-center">
                                      <button
                                        className="btn btn-outline-primary btn-sm text-wrap"
                                        type="button"
                                        onClick={() => {
                                          salida.setValue(
                                            "tipComprobante",
                                            "09",
                                            {
                                              shouldValidate: true,
                                            }
                                          );
                                          toast.dismiss();
                                        }}
                                      >
                                        Remitente
                                      </button>
                                    </div>
                                    <div className="col-6 d-flex justify-content-center">
                                      <button
                                        className="btn btn-outline-primary btn-sm text-wrap"
                                        type="button"
                                        onClick={() => {
                                          salida.setValue(
                                            "tipComprobante",
                                            "31",
                                            {
                                              shouldValidate: true,
                                            }
                                          );
                                          toast.dismiss();
                                        }}
                                      >
                                        Transportista
                                      </button>
                                    </div>
                                  </div>
                                ),
                              }
                            );
                            setEstado(false);
                            setData([]);
                          }}
                        >
                          Salida
                        </a>
                      </li>
                    </ul>

                    <div className="tab-content mt-3" id="myTabContent">
                      <div
                        className={`tab-pane fade ${estado ? "show active" : ""}`}
                        id="tab-home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        <div className="col-12 col-sm-6 col-xl-12">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="add-property-wizard-phone"
                            >
                              Observaciones
                            </label>
                            <textarea
                              className="form-control rounded-4"
                              id="exampleTextarea"
                              placeholder="Escribe la observación de tu entrada aquí..."
                              rows="3"
                              {...entrada.register("glosa", {
                                maxLength: {
                                  value: 500,
                                  message: "Descripción demasiada larga",
                                },
                              })}
                              defaultValue=""
                            />
                            {entrada.formState.errors?.obs && (
                              <code>
                                {entrada.formState.errors.obs.message}
                              </code>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="col-12 col-sm-6 col-xl-12">
                          <div className="mb-2">
                            <div className="d-flex flex-wrap mb-2">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Proveedor
                              </h5>
                              <NavLink
                                className="fw-bold fs-9"
                                to={"/main/NuevoCliente"}
                              >
                                Nuevo proveedor
                              </NavLink>
                            </div>
                            <Select
                              className="mb-0 mi-select mi-select-bordered"
                              classNamePrefix="rs"  
                              styles={customStyles}
                              placeholder="Selecciona un proveedor"
                              options={clientes}
                              value={
                                clientes.find(
                                  (option) =>
                                    option.value === entrada.watch("idcont")
                                ) || null
                              }
                              {...entrada.register("idcont", {
                                required: {
                                  value: true,
                                  message: "Este campo es obligatorio",
                                },
                              })}
                              onChange={(event) => {
                                entrada.setValue("idcont", event.value);
                              }}
                            />
                            {entrada.formState.errors?.idcont && (
                              <code>
                                {entrada.formState.errors.idcont.message}
                              </code>
                            )}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-6">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Área
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/AreaLocal"}
                              >
                                Nuevo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un área"
                                options={area}
                                value={
                                  area.find(
                                    (option) =>
                                      option.value === entrada.watch("idArea")
                                  ) || null
                                }
                                {...entrada.register("idArea", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idArea", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idArea && (
                                <code>
                                  {entrada.formState.errors.idArea.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Local
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/AreaLocal"}
                              >
                                Nuevo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un local"
                                options={local}
                                value={
                                  local.find(
                                    (option) =>
                                      option.value === entrada.watch("idLocal")
                                  ) || null
                                }
                                {...entrada.register("idLocal", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idLocal", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idLocal && (
                                <code>
                                  {entrada.formState.errors.idLocal.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Almacén
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Almacen"}
                              >
                                Nuevo almacén
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un almacén"
                                options={almacen}
                                value={
                                  almacen.find(
                                    (option) =>
                                      option.value ===
                                      entrada.watch("idAlmacen")
                                  ) || null
                                }
                                {...entrada.register("idAlmacen", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idAlmacen", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idAlmacen && (
                                <code>
                                  {entrada.formState.errors.idAlmacen.message}
                                </code>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                          <h4 className="mb-0">Total :</h4>
                          <h4 className="mb-0">
                            {
                              moneda.find((mon) => mon.value === idMoneda)
                                ?.label
                            }{" "}
                            {" " + parseFloat(stadicts.total).toFixed(2)}
                          </h4>
                        </div>
                      </div>
                      <div
                        className={`tab-pane fade ${estado ? "" : "show active"}`}
                        id="tab-profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        {tipo !== "" && tipo !== "GE" && (
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="fs-9 text-body-tertiary fw-bold mb-0 d-flex align-items-center">
                              <span className="fa-solid far fa-file-alt text-body-secondary me-2"></span>
                              {tipo === "09"
                                ? "Guía de remisión remitente"
                                : tipo === "31"
                                ? "Guía de remisión transportista"
                                : "Guía de remisión"}
                            </p>
                            <button
                              className="btn-close h-75"
                              type="button"
                              aria-label="Close"
                              onClick={() => {
                                salida.setValue("tipComprobante", "", {
                                  shouldValidate: true,
                                });
                              }}
                            ></button>
                          </div>
                        )}
                        <div className="row mb-2">
                          <div className="col-lg-12 mb-2">
                            <div className="d-flex flex-wrap mb-2">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Cliente
                              </h5>
                              <NavLink
                                className="fw-bold fs-9"
                                to={"/main/NuevoCliente"}
                              >
                                Nuevo cliente
                              </NavLink>
                            </div>
                            <Select
                              className="mb-0 mi-select mi-select-bordered"
                              classNamePrefix="rs"  
                              styles={customStyles}
                              placeholder="Selecciona un cliente"
                              options={clientes}
                              value={
                                clientes.find(
                                  (option) =>
                                    option.value === salida.watch("idcont")
                                ) || null
                              }
                              {...salida.register("idcont", {
                                required: {
                                  value: true,
                                  message: "Este campo es obligatorio",
                                },
                              })}
                              onChange={(event) => {
                                salida.setValue("idcont", event.value);
                              }}
                            />
                            {salida.formState.errors?.idcont && (
                              <code>
                                {salida.formState.errors.idcont.message}
                              </code>
                            )}
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Motivo de traslado
                              </label>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un motivo de traslado"
                                options={tipTraslado}
                                value={
                                  tipTraslado.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idTipTraslado")
                                  ) || null
                                }
                                {...salida.register("idTipTraslado", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idTipTraslado", event.value);
                                }}
                              />
                              {salida.formState.errors?.idTipTraslado && (
                                <code>
                                  {
                                    salida.formState.errors.idTipTraslado
                                      .message
                                  }
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Punto de llegada
                              </label>
                              <input
                                className="form-control input-spin-none rounded-4"
                                id="exampleFormControlInput"
                                type="text"
                                {...salida.register("puntPartida", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {salida.formState.errors?.puntPartida && (
                                <code>
                                  {salida.formState.errors.puntPartida.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Punto de partida
                              </label>
                              <input
                                className="form-control input-spin-none rounded-4"
                                id="exampleFormControlInput"
                                type="text"
                                {...salida.register("puntLlegada", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {salida.formState.errors?.puntLlegada && (
                                <code>
                                  {salida.formState.errors.puntLlegada.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <hr />
                          <div className="col-lg-12 mb-1">
                            <div className="d-flex flex-wrap mb-1">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Datos de transporte
                              </h5>
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Vehículo
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Vehiculo"}
                              >
                                Nuevo vehículo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un vehículo"
                                options={vehiculo}
                                value={
                                  vehiculo.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idVehiculo")
                                  ) || null
                                }
                                {...salida.register("idVehiculo", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idVehiculo", event.value);
                                }}
                              />
                              {salida.formState.errors?.idVehiculo && (
                                <code>
                                  {salida.formState.errors.idVehiculo.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Conductor
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Vehiculo"}
                              >
                                Nuevo conductor
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"  
                                styles={customStyles}
                                placeholder="Selecciona un conductor"
                                options={conductor}
                                value={
                                  conductor.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idConductor")
                                  ) || null
                                }
                                {...salida.register("idConductor", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idConductor", event.value);
                                }}
                              />
                              {salida.formState.errors?.idConductor && (
                                <code>
                                  {salida.formState.errors.idConductor.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                            <h4 className="mb-0">Total :</h4>
                            <h4 className="mb-0">
                              {
                                moneda.find((mon) => mon.value === idMoneda)
                                  ?.label
                              }{" "}
                              {" " + parseFloat(stadicts.total).toFixed(2)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="false"
        ref={modalConfiguracion}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Configuración de inventario
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h5 className="mb-3">Opciones generales</h5>

              <div className="p-3 border rounded-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    id="flexSwitchCheckChecked"
                    type="checkbox"
                    checked={igv}
                    onChange={() => {
                      setIgv(!igv);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckChecked"
                  >
                    Impuesto General a las Ventas (IGV)
                  </label>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 mt-2">
                    <p className="fw-bold">Entrada</p>
                  </div>
                  <div className="col-lg-4">
                    <select
                      className="form-select rounded-4"
                      value={serComprobante.entrada}
                      onChange={(e) =>
                        setSerComprobante((prev) => ({
                          ...prev,
                          entrada: e.target.value,
                        }))
                      }
                    >
                      {series
                        .filter((s) => s.tipComprobante === "GE")
                        .map((s) => (
                          <option key={s.idSerie} value={s.serie}>
                            {s.serie}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <div className="bg-primary-subtle rounded-4 d-flex justify-content-center align-items-center mt-1" style={{ height: "50%" }}>
                      <p className="fs-9 text-primary fw-bold  mt-3">Por defecto</p>
                    </div>
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-lg-5 mt-2">
                    <p className="fw-bold">Guía remitente</p>
                  </div>
                  <div className="col-lg-4">
                    <select
                      className="form-select rounded-4"
                        value={serComprobante.remitente}
                        onChange={(e) =>
                          setSerComprobante((prev) => ({
                            ...prev,
                            remitente: e.target.value,
                          }))
                        }
                      >
                        {series
                          .filter((s) => s.tipComprobante === "09")
                          .map((s) => (
                            <option key={s.idSerie} value={s.serie}>
                              {s.serie}
                            </option>
                          ))}
                      </select>
                  </div>
                  <div className="col-lg-3">
                    <div className="bg-primary-subtle rounded-4 d-flex justify-content-center align-items-center mt-1" style={{ height: "50%" }}>
                      <p className="fs-9 text-primary fw-bold  mt-3">Por defecto</p>
                    </div>
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-lg-5 mt-2">
                    <p className="fw-bold">Guía transportista</p>
                  </div>
                  <div className="col-lg-4">
                    <select
                      className="form-select rounded-4"
                        value={serComprobante.transportista}
                        onChange={(e) =>
                          setSerComprobante((prev) => ({
                            ...prev,
                            transportista: e.target.value,
                          }))
                        }
                      >
                        {series
                          .filter((s) => s.tipComprobante === "31")
                          .map((s) => (
                            <option key={s.idSerie} value={s.serie}>
                              {s.serie}
                            </option>
                          ))}
                      </select>
                  </div>
                  <div className="col-lg-3">
                    <div className="bg-primary-subtle rounded-4 d-flex justify-content-center align-items-center mt-1" style={{ height: "50%" }}>
                      <p className="fs-9 text-primary fw-bold  mt-3">Por defecto</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade" 
        id="staticBackdrop" 
        tabIndex="-1" 
        data-bs-backdrop="static" 
        aria-labelledby="staticBackdropLabel" 
        aria-hidden="true"
        ref={modalConfirmacion}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-body">
              <div className="d-flex align-items-center py-2 mb-1" role="alert">
                <span className="fas fa-check-circle text-success fs-5"></span>
                <p className="mb-0 flex-1 text-center">
                  {estado ? "Entrada" : "Salida"} registrada correctamente
                </p>
                <button
                  className="btn-close"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <h6 className="fs-7 text-primary text-center mb-4">
                {comp.current}{" "}
                <span className="ms-2 text-secondary">
                  {money.current}
                  {monto.current}
                </span>
              </h6>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-phoenix-danger me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  title="Ver previo pdf"
                  type="button"
                  onClick={()=>{getReportInventario()}}
                >
                  <span className="far fa-file-pdf"></span>
                </button>
                <button
                  className="btn btn-phoenix-info me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  type="button"
                  title="Enviar por correo"
                  onClick={()=>{abrirModalEmailInventario()}}
                >
                  <span className="far fa-envelope"></span>
                </button>
                <button
                  className="btn btn-phoenix-success me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  title="Enviar por WhatsApp"
                  type="button"
                  onClick={()=>{abrirModalWspInventario()}}
                >
                  <span className="fab fa-whatsapp"></span>
                </button>
                <NavLink
                  className="btn btn-phoenix-success me-1 text-nowrap px-2 px-sm-4 d-inline-flex align-items-center rounded-4 border-0 shadow-sm"
                  title="Ir al listado de ventas"
                  type="button"
                  to={"/main/VerES"}
                  onClick={()=>{
                    const modalInstance = window.bootstrap.Modal.getInstance(modalConfirmacion.current);
                    modalInstance.hide();
                  }}
                >
                  <span className="fas fa-clipboard-list"></span>
                  <span className="ms-2 mt-1">Listado</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalEmail}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendEmail}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por correo electronico
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        @
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form1.register("email", {
                          required: "El email es requerido",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email no válido",
                          },
                        })}
                      />
                    </div>
                    {form1.formState.errors.email && (
                      <span className="text-danger">
                        {form1.formState.errors.email.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalWsp}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendWsp}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por WhatsApp
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        +
                      </span>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="51"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("indice", {
                          required: "El número es requerido",
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.indice && (
                      <span className="text-danger">
                        {form2.formState.errors.indice.message}
                      </span>
                    )}
                  </div>
                  <div className="col-lg-8">
                    <div className="input-group mb-1">
                      <input
                        className="form-control"
                        type="number"
                        placeholder="999 999 999"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("numero", {
                          required: "El número es requerido",
                          pattern: {
                            value: /^\+?[1-9]\d{1,14}$/,
                            message: "Número no válido",
                          },
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.numero && (
                      <span className="text-danger">
                        {form2.formState.errors.numero.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
